<template>
    <!-- 搜索框 -->
    <el-drawer class="search-pop" :visible.sync="searchVisible" direction="ttb" :before-close="handleClose">
        <div class="search-pop-content middle-main">
            <el-row :gutter="30">
                <el-col :span="isPc != 3 ? 16 : 24">
                    <h1>{{ L('站内搜索') }}</h1>
                    <el-input v-model="keyword" :placeholder="L('搜索你想要了解的内容')" clearable>
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                    <h3 v-if="!keyword">{{ L('热门关键词') }}</h3>
                    <div class="hot-keywords" v-if="!keyword">
                        <span v-for="item in tagList" :key="item.id" @click="getTagNews(item.name)">{{ item.name
                            }}</span>
                    </div>
                    <div class="search-res" v-if="keyword">
                        <news-list :newsTitle="keyword" img-direction="flex-row" @toDetails="toNewsDetail" />
                    </div>
                </el-col>
                <el-col :span="8" v-if="isPc != 3">
                    <h1>{{ L('热点新闻') }}</h1>
                    <div class="hot-news">
                        <div class="hot-news-item" v-for="item in hotNewsList" :key="item.newsId"
                            @click="toNewsDetail(item)">
                            <div class="hot-news-item-content">
                                <h4>{{ item.newsTitle }}</h4>
                                <p><em>{{ item.newstype }}</em> · {{ item.tag }}</p>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </el-drawer>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { getNewsList, getTagList } from "@/assets/api/news.js";
import newsList from "./news-list.vue";
export default {
    components: {
        newsList,
    },
    computed: {
        ...mapState(["isPc", "searchKeyword"]),
    },
    data() {
        return {
            searchVisible: false,
            keyword: '',
            tagList: [],
            hotNewsList: [],
            newsListRes: [],
        };
    },
    watch: {
        keyword: {
            handler(val) {
                if (val) {
                    // this.getSearchRes();
                }
            },
        },
        searchKeyword(newVal) {
            this.keyword = newVal;
        }
    },
    mounted() {
        this.getHotKeywords();
        this.getHotNews();
    },
    methods: {
        ...mapActions(['setSearchKeyword', 'triggerSearch']),
        getSearchRes() {
            let params = {
                orderByColumn: "releaseTime",
                isAsc: "desc",
                typeId: "",
                // newsTitle: this.keyword,
                // tag: this.keyword,
                pageNum: 1,
                pageSize: 6,
                slideshow: 0,
            }
            console.log('this.keyword====', this.keyword.includes('#'))
            if (this.keyword.includes('#')) {
                // 如果是#号开头，则认为是标签,去掉#号  
                params.tag = this.keyword.replace('#', '')
            } else {
                // 如果不是#号开头，则认为是新闻标题
                params.newsTitle = this.keyword
            }

            getNewsList(params).then((res) => {
                this.newsListRes = res.data.rows.map((item) => {
                    item.newsImage = !/^http/.test(item.newsImage)
                        ? this.$imgUrl + item.newsImage
                        : item.newsImage;
                    return item;
                });
            });
        },
        handleClose() {
            this.searchVisible = false;
            this.keyword = '';

            // this.setSearchKeyword('');
            // this.triggerSearch();
        },
        getHotKeywords() {
            getTagList().then((res) => {
                this.tagList = res.data.rows.map((item, index) => {
                    return {
                        name: item,
                        id: index,
                    };
                });
            });
        },
        getTagNews(name) {
            this.keyword = '#' + name;
            this.setSearchKeyword(this.keyword);
            this.triggerSearch();
        },
        getHotNews() {
            getNewsList({
                page: 1,
                pageSize: 3,
                orderByColumn: "tips",
                isAsc: "desc",
            }).then((res) => {
                this.hotNewsList = res.data.rows.map((item) => {
                    item.tag = item.tag.split('|').join(' · ');

                    return item;
                });
            });
        },
        toNewsDetail(item) {
            this.searchVisible = false;
            this.keyword = '';
            localStorage.setItem('newsId', item.newsId);
            let path = item.seoUrl ? item.seoUrl : item.newsId
            this.$router.push({
                path: `/${path}.html`,
            });
        },
        generateSlug(title) {
            // 将标题中的空格替换为连字符
            let slug = title.toLowerCase().replace(/\s+/g, '-');
            // 将连字符替换为单个连字符
            slug = slug.replace(/-+/g, '');
            slug = slug.replace(/:+/g, '');
            return slug;
        },
    },
};

</script>
<style lang="less" scoped>
.search-pop {
    width: 100%;
    height: 100%;

    .search-pop-content {
        padding-bottom: 40px;

        h1 {
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 32px;
            color: #2C2C2E;
            line-height: 42px;
            text-align: left;
            font-style: normal;
            margin-bottom: 30px;
            margin-top: 60px;
        }

        h3 {
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 24px;
            color: #2C2C2E;
            line-height: 31px;
            text-align: left;
            font-style: normal;
            margin-bottom: 20px;
            margin-top: 40px;
        }

        .hot-keywords {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            margin-bottom: 20px;
            background: #FFFFFF;

            span {
                font-family: MicrosoftYaHei;
                font-size: 16px;
                color: #2C2C2E;
                line-height: 20px;
                text-align: center;
                font-style: normal;
                border-radius: 25px;
                border: 1px solid #E5E5EA;
                padding: 14px 23px;
                cursor: pointer;

                &:hover {
                    border: 1px solid #E2291E;
                }
            }
        }
    }

    .search-res {
        margin-top: 30px;
        margin-bottom: 30px;
        height: 10%;
    }
}

.hot-news {
    margin-top: -20px;

    .hot-news-item {
        padding: 20px 0;
        border-bottom: 1px solid #E5E5EA;
        cursor: pointer;

        .hot-news-item-content {
            h4 {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 18px;
                color: #2C2C2E;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                margin-bottom: 6px;
            }

            p {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #AEAEB2;
                line-height: 19px;
                text-align: left;
                font-style: normal;

                em {
                    color: #E2291E;

                }
            }
        }

        &:last-child {
            border-bottom: none;
        }

        &:hover {
            h4 {
                color: #E2291E;
            }
        }
    }
}

@media (max-width: 768px) {
    .search-pop {
        .search-pop-content {
            padding: 0 20px;

            h1 {
                font-size: 24px;
                line-height: 31px;
                margin: 30px 0 20px 0;
            }

            h3 {
                font-size: 16px;
                line-height: 21px;
                margin: 30px 0 12px 0;

            }

            .hot-keywords {
                margin-bottom: 40px;

                span {
                    font-size: 14px;
                    line-height: 19px;
                    padding: 10px 20px;
                }
            }
        }
    }

}
</style>
<style>
.v-modal {
    /* top: 120px; */
    z-index: 2000 !important;
}

.search-pop .el-drawer {
    background-color: #fff;
    height: auto !important;
    max-height: 100%;
    overflow: hidden;
}

.search-pop .el-input-group {
    background: #FFFFFF;
    border-radius: 30px;
    border: 2px solid #E5E5EA;
}

.search-pop .el-input-group--append .el-input__inner {
    border: none;
    border-radius: 30px;
    height: 60px;
    padding: 0 30px;

}

.search-pop .el-input-group__append {
    background: #FFFFFF;
    border: none;
    border-radius: 30px;
    color: #2C2C2E;
    padding: 0 30px;

}

@media (max-width: 768px) {
    .search-pop .el-input-group {
        background: #FFFFFF;
        border-radius: 30px;
        border: 2px solid #E5E5EA;
    }

    .search-pop .el-input-group--append .el-input__inner {
        border: none;
        border-radius: 30px;
        height: 50px;
        padding: 0 20px;

    }

    .search-pop .el-input-group__append {
        background: #FFFFFF;
        border: none;
        border-radius: 30px;
        color: #2C2C2E;
        padding: 0 20px;

    }
}
</style>



// WEBPACK FOOTER //
// src/views/common/search-pop.vue